import { ChartsColors } from '../../../../../../../../../constants/charts';
import dayjs from 'dayjs';

const chartConfig = {
  xField: 'timestamp',
  yField: 'temperature',
  seriesField: 'channel',
  theme: {
    styleSheet: {
      fontFamily: 'Acciona Font',
    },
  },
  meta: {
    timestamp: {
      tickCount: 5,
      formatter: (v, i) => dayjs(v).format('DD/MM/YYYY'),
    },
    temperature: {
      formatter: (v) => `${v}ºC`,
    },
  },
  color: () => {
    return ChartsColors[0];
  },
};

export default chartConfig;
